import { Topbar } from '@/components/organisms/Topbar';
import { PartnerIntegrationCardSkeleton } from './PartnerIntegrationCardSkeleton';

/**
 * `/partner-integration` route pending state: Topbar + the same card skeleton
 * the section itself renders while its org / integration reads are in flight,
 * so the route-transition placeholder and the in-page one are one block that
 * does not resize when the first hands over to the second.
 */
export function PartnerIntegrationPendingState() {
  return (
    <>
      <Topbar
        crumbs={[{ label: 'Organization' }, { label: 'Partner Integration' }]}
        title="Partner Integration"
      />
      <div className="flex min-h-0 flex-1 flex-col overflow-auto" style={{ background: 'var(--canvas)' }}>
        <div
          className="mx-auto flex w-full flex-col gap-6 px-4 py-6 md:px-8 md:py-6"
          aria-busy="true"
          aria-live="polite"
        >
          <PartnerIntegrationCardSkeleton />
        </div>
      </div>
    </>
  );
}
